(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    
  const apps = document.querySelectorAll('.cc-apps');
  if (apps.length > 0) {
    apps.forEach((app) => {
      const observer = new MutationObserver(() => {
        const contestParticipation = app.querySelector(
          '[data-forms-id="forms-root-725331"], [data-forms-id="forms-root-726175"]'
        );
        if (!contestParticipation) return;
        const form = contestParticipation.querySelector('shopify-forms-embed');
        if (!form) return;
        addStyleSheet(form);
      });
      observer.observe(app, { childList: true, subtree: true, characterData: true });
    });
  }

  function addStyleSheet(form) {
    const newSheet = new CSSStyleSheet();
    newSheet.replaceSync(`
    #form-container-ref {
      [class^='_formContainer'] {
        max-width: 100%;

        [class^='_formHeader'] {
          margin-bottom: calc(6 * var(--space-unit));
          h2,
          [class^='_textHeading'] {
            color: rgb(var(--heading-color));
            text-align: center;
            font-size: var(--h4-font-size);
            line-height: 1.3;
            margin: 0 0 .4em;
            margin-bottom: var(--heading-gap);
            font-family: Akzidenz, sans-serif;
            font-style: var(--heading-font-style);
            font-weight: var(--heading-font-weight);
            letter-spacing: var(--heading-letter-spacing);
            text-transform: var(--heading-text-transform);
          }

          p,
          [class^='_textBody'] {
            max-width: var(--page-width, 48em);
            font-family: var(--body-font-family);
            font-size: calc(var(--body-font-size) * .1rem);
            font-style: var(--body-font-style);
            font-weight: var(--body-font-weight);
            letter-spacing: var(--body-letter-spacing);
            line-height: 1.5;
            text-align: left;
            color: currentColor;
          }
        }
        
        form {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          grid-template-rows: repeat(8, auto);
          column-gap: var(--column-gap);
          row-gap: 0;
          grid-template-areas:
          "first-name last-name"
          "first-name-error last-name-error"
          "company company"
          "company-error company-error"
          "postal-code company-size"
          "postal-code-error company-size"
          "email phone"
          "email-error phone"
          "button button"
          ;
          align-items: flex-start;
          font-family: var(--body-font-family);

          @media screen and (max-width: 768px) {
            grid-template-columns: minmax(0, 1fr);
            grid-template-areas:
              "first-name"
              "first-name-error"
              "last-name"
              "last-name-error"
              "company"
              "company-error"
              "postal-code"
              "postal-code-error"
              "company-size"
              "email"
              "email-error"
              "phone"
              "button"
              ;
          }

          & > [class^='_formError'] {
            margin-top: 10px;
            margin-bottom: 0;
          }

          & > [class^='_formFieldContainer'],
          & > [class^='_selectContainer'],
          & > [class^='_formPhoneInputContainer'],
          & > button[type="submit"] {
            margin-top: calc(6 * var(--space-unit));
          }

          [class^='_formFieldContainer'] {
            grid-column: span 2;
            flex-direction: column-reverse;

            &:has(input#first_name) {
              margin-top: 0;
              grid-area: first-name;
              & + [class^='_formError'] {
                grid-area: first-name-error;
              }
            }
            &:has(input#last_name) {
              margin-top: 0;
              grid-area: last-name;
              & + [class^='_formError'] {
                grid-area: last-name-error;
              }
              @media screen and (max-width: 768px) {
                margin-top: calc(6 * var(--space-unit));
              }
            }
            &:has(input[id="custom#nom_de_lentreprise"]) {
              grid-area: company;
              & + [class^='_formError'] {
                grid-area: company-error;
              }
            }
            &:has(input[type="number"]) {
              grid-area: postal-code;
              & + [class^='_formError'] {
                grid-area: postal-code-error;
              }
            }
            &:has(input#email) {
              grid-area: email;
              & + [class^='_formError'] {
                grid-area: email-error;
              }
            }
          }

          [class^='_formFieldContainer'],
          [class^='_selectContainer'] {
            [class^='_formInputFieldLabel'],
            [class^='_label']  {
              position: unset;
              display: block;
              margin: 0 0 calc(2 * var(--space-unit));
              margin-block-end: calc(2 * var(--space-unit)) !important;
              padding-bottom: 0;
              font-family: var(--body-font-family);
              font-size: .88em;
              font-weight: 700;
              text-align: start;
              color: currentColor;
              transform: none;
              line-height: 1.5;
            }

            input, button {
              max-width: 100%;
              margin: 0;
              padding: var(--input-padding-y, 11px) 24px;
              transition: border-color .2s, box-shadow .2s, outline .2s;
              border: var(--input-border-width) solid rgba(var(--input-text-color) / .2);
              border-radius: var(--input-border-radius, 0);
              background-color: rgb(var(--input-bg-color));
              color: rgb(var(--input-text-color));
              font-family: var(--body-font-family);
              font-size: var(--btn-text-size);
              line-height: 1.2em;

              box-shadow: none;

              &:focus {
                border-color: rgba(var(--input-text-color) / .6);
                outline: 0;
                box-shadow: 0 0 0 1px rgba(var(--input-text-color) / .6);
              }
            }
          }

          [class^='_selectContainer'] {
            grid-area: company-size;

            [class^='_selectToggle'] {
              [class^='_arrowDownIcon'] {
                display: block;
                position: relative;
                margin: 0;

                svg {
                  opacity: 0;
                }

                &::after {
                  content: "";
                  position: absolute;
                  top: calc(50% - 10px);
                  right: 0;
                  width: 20px;
                  height: 20px;
                  background-color: rgb(var(--input-text-color));
                  pointer-events: none;
                  -webkit-mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'><path d='M20 8.5 12.5 16 5 8.5' fill='none' stroke='currentColor' stroke-width='1.5'/></svg>");
                  mask-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24'><path d='M20 8.5 12.5 16 5 8.5' fill='none' stroke='currentColor' stroke-width='1.5'/></svg>");
                }
              }
            }
          
          }

          [class^='_formPhoneInputContainer'] {
            grid-area: phone;
            grid-template-rows: auto auto;
            grid-template-areas: 'label label'
            'country input';
            row-gap: 0;

            [class^='_formError'] {
              margin-top: 10px;
            }

            [class^='_formFieldContainer'] {
              display: contents;

              [class^='_formInputFieldLabel'] {
                order: -1;
                grid-area: label;
              }

              input {
                grid-area: input;
              }

              .phone-country-selector {
                grid-area: country;
              }
            }
          }

          button[type="submit"] {
            grid-area: button;
            display: inline-block;
            position: relative;
            max-width: 100%;
            transition: opacity .6s ease, color .6s ease, background-position .4s ease-out;
            border-radius: var(--btn-border-radius, 0);
            font-size: var(--btn-text-size);
            font-weight: 700;
            line-height: 1.2em;
            text-align: center;
            text-transform: var(--btn-text-transform, none);
            -webkit-appearance: none;
            appearance: none;
            word-break: break-word;

            width: fit-content;
            grid-column: span 2;
            padding: calc(var(--btn-padding-y, 12px) + var(--btn-border-width)) calc(20px + var(--btn-border-width) * 2);
            border: 0;
            outline-color: rgb(var(--btn-bg-color));
            outline-offset: 3px;
            background: rgb(var(--btn-bg-hover-color)) linear-gradient(104deg,rgb(var(--btn-bg-hover-color)) 60%,rgb(var(--btn-bg-color)) 60% 100%) no-repeat 100% 100%;
            background-size: 300% 100%;
            color: rgb(var(--btn-text-color));

            @media (hover: hover) and (pointer: fine) {
              &:hover {
                background-position: 0 100%;
              }
            }
          }

         
        }
      }
    }
   
  `);

    // Access shadow root
    const el = form;
    const shadow = el.shadowRoot;

    // Keep the existing stylesheets
    const currentSheets = shadow.adoptedStyleSheets;

    // Append the new stylesheet
    shadow.adoptedStyleSheets = [...currentSheets, newSheet];
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
